import { createSelector } from "reselect";
import _ from "underscore";

import getTradesFilter from "./get_trades_filter";

const getSelectedTradeCodes = createSelector([
  getTradesFilter
], (tradesFilter) => new Set(_.chain(tradesFilter)
  .pick((trade) => trade?.selected === 1 || trade?.selected === -1)
  .keys()
  .value()) as Set<string>);

export default getSelectedTradeCodes;
